"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateDistributionRanks = exports.calculateActualPlaces = exports.calculateRanksCount = void 0;
const lodash_1 = require("lodash");
const enums_1 = require("../enums");
const INDEX_NORMALIZER = 1;
const FIRST_POSITION = 1;
const POW_OF_TWO = 2;
const MIN_ROUND_COUNTS = 2;
const calculateActualTeamsCount = ({ minTeamsCount, activeTeamsCount, }) => {
    return Math.max(minTeamsCount, activeTeamsCount);
};
const calculateRanksCount = ({ activeTeamsCount, lastWinningPosition, minTeamsCount, isKnockoutTournament, isFreeTournament, payoutType, thresholdPercentage, }) => {
    if (isFreeTournament) {
        return FIRST_POSITION;
    }
    const teamsCount = calculateActualTeamsCount({ minTeamsCount, activeTeamsCount });
    const winningPosition = Math.min(lastWinningPosition, teamsCount);
    if (payoutType === enums_1.TournamentPayoutType.TopPercent) {
        return (winningPosition * thresholdPercentage) / 100;
    }
    if (!isKnockoutTournament) {
        return winningPosition;
    }
    switch (true) {
        case winningPosition === FIRST_POSITION:
            return FIRST_POSITION;
        case winningPosition > MIN_ROUND_COUNTS:
            return Math.log(winningPosition - INDEX_NORMALIZER) / Math.log(POW_OF_TWO) + MIN_ROUND_COUNTS;
        default:
            return MIN_ROUND_COUNTS;
    }
};
exports.calculateRanksCount = calculateRanksCount;
const calculateActualPlaces = ({ activeTeamsCount, minTeamsCount, maxTeamsCount, isKnockoutTournament, isFreeTournament, ranksCount, }) => {
    if (isFreeTournament) {
        return [(0, lodash_1.range)(FIRST_POSITION, maxTeamsCount + INDEX_NORMALIZER || FIRST_POSITION)];
    }
    if (!isKnockoutTournament) {
        return (0, lodash_1.range)(FIRST_POSITION, ranksCount + INDEX_NORMALIZER).map((position) => [position]);
    }
    const teamsCount = calculateActualTeamsCount({ minTeamsCount, activeTeamsCount });
    return new Array(Math.round(ranksCount))
        .fill(null)
        .map((team, index) => {
        if (!index) {
            return [index + INDEX_NORMALIZER];
        }
        if (index === FIRST_POSITION && ranksCount >= MIN_ROUND_COUNTS) {
            return [index + INDEX_NORMALIZER];
        }
        const start = Math.pow(POW_OF_TWO, index - INDEX_NORMALIZER) + INDEX_NORMALIZER;
        if (start > teamsCount) {
            return [];
        }
        let end = Math.pow(POW_OF_TWO, index);
        if (end > teamsCount) {
            end = teamsCount;
        }
        return (0, lodash_1.range)(start, end + INDEX_NORMALIZER);
    })
        .filter((tournamentPlaces) => tournamentPlaces.length);
};
exports.calculateActualPlaces = calculateActualPlaces;
const MIN_SINGLE_ELIMINATION_RANK_COUNTS = 1;
const generateDistributionRanks = (places, isKnockoutTournament) => {
    const ranksCount = places.length;
    if (!ranksCount || ranksCount < MIN_SINGLE_ELIMINATION_RANK_COUNTS) {
        return [];
    }
    if (!isKnockoutTournament) {
        return (0, lodash_1.range)(ranksCount, 0, -1);
    }
    const ranks = [];
    for (let i = 0; i < ranksCount; i++) {
        ranks.push((ranksCount - i) * places[i].length);
    }
    return ranks;
};
exports.generateDistributionRanks = generateDistributionRanks;
//# sourceMappingURL=calculate-tournament-places.js.map